module.exports = __webpack_public_path__ + "img/TrustServiceCategor7.2617c2be.png";